const LOCALHOST_HOSTNAMES = new Set(['localhost', '127.0.0.1', '::1'])

/**
 * Email/password Firebase auth UI is only offered on these hostnames so
 * deployed sites never expose it; production keeps Google-only sign-in.
 */
export const isEmailPasswordAuthHost = (hostname: string): boolean => LOCALHOST_HOSTNAMES.has(hostname)
